import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Hartje } from '../Iconen.jsx';
import Venster from '../Venster.jsx';

export default function Viewer({ v }) {
  if (!v.showViewer) return null;
  return (
    <Venster v={v} venster={v.viewerVenster} titel={v.viewerTitle} onSluit={v.closeViewer}>
      <div style={css(v.viewerPanelStyle)}>
          {' '}
          <div style={css(v.viewerTopBarStyle)}>
            {' '}
            <div style={{ "flex": "1 1 auto", "minWidth": "0", "display": "flex", "justifyContent": "flex-start" }}>
              <div style={{ "display": "flex", "gap": "6px", "minWidth": "0" }}>
                {v.viewerRequested ? (<>
                  <span style={{ "display": "inline-flex", "alignItems": "center", "gap": "7px", "minWidth": "0", "background": "var(--groen-vlak)", "color": "var(--groen-ink)", "border": "3px solid var(--groen)", "borderRadius": "999px", "padding": "0 13px 0 10px", "height": "30px", "boxSizing": "border-box", "fontSize": "13px", "fontWeight": "700", "lineHeight": "1", "marginTop": "-2px" }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.3" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                      <rect x="2" y="4" width="20" height="16" rx="3" />
                      <path d="m3 7 9 6 9-6" />
                    </svg>
                    <span style={{ "minWidth": "0", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                      <Interp v={v.viewerRequestLabel} />
                    </span>
                  </span>
                </>) : null}
                {v.viewerThemeMatch ? (<>
                  <span style={{ "display": "inline-flex", "alignItems": "center", "gap": "7px", "minWidth": "0", "background": "var(--geel-vlak)", "color": "var(--geel-ink)", "border": "3px solid var(--geel)", "borderRadius": "999px", "padding": "0 13px 0 10px", "height": "30px", "boxSizing": "border-box", "fontSize": "13px", "fontWeight": "700", "lineHeight": "1", "marginTop": "-2px" }}>
                    <span style={{ "fontSize": "14px" }}>
                      🎨
                    </span>
                    <span style={{ "minWidth": "0", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                      <Interp v={v.viewerThemeLabel} />
                    </span>
                  </span>
                </>) : null}
              </div>
            </div>
            {' '}
          </div>
          {' '}
          {v.viewerIsStatic ? (<>
            {' '}
            <img src={v.viewerSrc} alt={v.viewerAlt} style={css(v.viewerImgStyle)} />
            {' '}
          </>) : null}
          {' '}
          {v.viewerIsAnim ? (<>
            {' '}
            <div style={css(v.viewerAnimStyle)} />
            {' '}
          </>) : null}
          {' '}
          <div style={css(v.viewerRowStyle)}>
            {' '}
            <div style={css(v.viewerTitleColStyle)}>
              {' '}
              <div style={css(v.viewerTitleStyle)}>
                <Interp v={v.viewerTitle} />
              </div>
              {' '}
              <div style={css(v.viewerMetaStyle)}>
                {' '}
                {v.showViewerAvatar ? (<>
                  {' '}
                  <img alt="" onClick={v.openViewerAuthor} src={v.viewerAvatarUrl} title={v.viewerAuthorTitle} style={{ "width": "20px", "height": "20px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto", "cursor": "pointer" }} />
                  {' '}
                </>) : null}
                {' '}
                <span>
                  <Interp v={v.viewerAuthor} />
                  {", "}
                  <Interp v={v.viewerWhen} />
                </span>
                {' '}
              </div>
              {' '}
            </div>
            {' '}
            <div style={css(v.viewerActionsStyle)}>
              {' '}
              {/* Hier stond een tweede knop met een poppetje, alleen op de telefoon,
                  om te zien wie het leuk vond. Twee knoppen voor één hartje. Het
                  hartje doet het nu zelf: bij je eigen krabbel opent een tik de
                  lijst, want liken doe je je eigen werk niet. */}
              <div style={{ "position": "relative", "display": "flex", "flex": "0 0 auto" }} onMouseEnter={v.showLikers} onMouseLeave={v.hideLikers}>
                <button onClick={v.viewerLike} className="gp-btn" title={v.viewerHeartTitle} style={css(v.viewerBtnStyle)}>
                  {' '}
                  <Hartje maat={18} gevuld={v.viewerHeartGevuld} />
                  {' '}
                  <Interp v={v.viewerLikes} />
                  {' '}
                </button>
                {v.showViewerLikers ? (<>
                  <div style={css(v.likersPopStyle)}>
                    {' '}
                    <div style={{ "fontSize": "11px", "fontWeight": "700", "color": "var(--tekst-2)", "letterSpacing": ".05em", "textTransform": "uppercase" }}>
                      <Interp v={v.likersLabel} />
                    </div>
                    {' '}
                    {toList(v.viewerLikers).map((l, $index) => (
                      <React.Fragment key={$index}>
                        {' '}
                        <div style={{ "display": "flex", "alignItems": "center", "gap": "7px", "fontSize": "13px", "fontWeight": "700", "whiteSpace": "nowrap" }}>
                          <img alt="" src={l?.avatarUrl} style={{ "width": "22px", "height": "22px", "borderRadius": "999px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                          <span style={{ "flex": "1 1 auto" }}>
                            <Interp v={l?.name} />
                          </span>
                          <span style={{ "fontSize": "11px", "fontWeight": "600", "color": "var(--tekst-3)" }}>
                            <Interp v={l?.when} />
                          </span>
                        </div>
                        {' '}
                      </React.Fragment>
                    ))}
                    {' '}
                    {v.showAnonLikes ? (<>
                      {' '}
                      <div style={{ "fontSize": "12px", "fontWeight": "600", "color": "var(--tekst-2)", "lineHeight": "1.4", "maxWidth": "190px", "textWrap": "pretty" }}>
                        <Interp v={v.anonLikesLabel} />
                      </div>
                      {' '}
                    </>) : null}
                    {' '}
                  </div>
                </>) : null}
              </div>
              {' '}
            </div>
            {' '}
          </div>
          {' '}
          <div style={css(v.viewerCommentsStyle)}>
            {v.hasComments ? (<>
              {/* Op de telefoon scrollen de reacties in hun eigen strook, zodat het
                  tekstvak eronder altijd in beeld blijft. Geen rand en geen vakje
                  eromheen: je merkt het aan wat er beweegt, niet aan een lijn. */}
              <div style={css(v.viewerCommentListStyle)}>
                {toList(v.viewerComments).map((c, $index) => (
                  <React.Fragment key={$index}>
                    <div style={css(c?.bubbleStyle)}>
                      {' '}
                      <div style={{ "display": "flex", "alignItems": "center", "gap": "8px" }}>
                        <img alt="" src={c?.avatarUrl} style={{ "width": "26px", "height": "26px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                        <span style={{ "fontSize": "13px", "fontWeight": "700", "color": "var(--ink)", "flex": "1 1 auto", "minWidth": "0", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                          <Interp v={c?.author} />
                        </span>
                        <span style={{ "fontSize": "11px", "fontWeight": "600", "color": "var(--tekst-3)", "flex": "0 0 auto", "lineHeight": "26px" }}>
                          <Interp v={c?.when} />
                        </span>
                        {c?.canDelete ? (<>
                          <button onClick={c?.onDelete} title="Reactie weghalen" style={{ "display": "flex", "alignItems": "center", "justifyContent": "center", "width": "26px", "height": "26px", "flex": "0 0 auto", "border": "2px solid var(--rand-stippel)", "borderRadius": "8px", "background": "transparent", "cursor": "pointer", "color": "var(--tekst-3)", "padding": "0" }} className="gp-h2">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.8" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M3 6h18" />
                              <path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
                              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                              <path d="M10 11v6" />
                              <path d="M14 11v6" />
                            </svg>
                          </button>
                        </>) : null}
                      </div>
                      {' '}
                      <div style={{ "fontSize": "15px", "fontWeight": "600", "lineHeight": "1.4", "color": "var(--ink)", "overflowWrap": "anywhere", "textWrap": "pretty" }}>
                        <Interp v={c?.text} />
                      </div>
                      {' '}
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </>) : null}
            {v.showCommentForm ? (<>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "8px", "flex": "0 0 auto" }}>
                <div style={{ "flex": "1 1 auto", "minWidth": "0", "display": "flex", "flexDirection": "column" }}>
                  <input type="text" value={v.commentText ?? ''} onInput={v.onCommentInput} onKeyDown={v.onCommentKey} placeholder="Zeg iets aardigs over deze krabbel…" />
                </div>
                <button onClick={v.submitComment} className="gp-btn p" disabled={v.commentBlocked} title="Plaats je reactie" style={{ "flex": "0 0 auto", "height": "44px", "width": "44px", "padding": "0", "justifyContent": "center" }}>
                  {' '}
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  {' '}
                </button>
              </div>
            </>) : null}
            {v.commentDone ? (<>
              <div style={{ "fontSize": "12px", "fontWeight": "600", "color": "var(--tekst-3)", "lineHeight": "1.4" }}>
                Je kunt helaas niet nóg een comment plaatsen.
              </div>
            </>) : null}
            {v.hasCommentError ? (<>
              <div style={{ "fontSize": "13px", "color": "var(--fout)", "fontWeight": "600", "lineHeight": "1.4" }}>
                <Interp v={v.commentError} />
              </div>
            </>) : null}
          </div>
          {' '}
      </div>
    </Venster>
  );
}
